import { render, staticRenderFns } from "./TestSecretPay.vue?vue&type=template&id=6b04a89c&scoped=true&"
import script from "./TestSecretPay.vue?vue&type=script&lang=js&"
export * from "./TestSecretPay.vue?vue&type=script&lang=js&"
import style0 from "./TestSecretPay.vue?vue&type=style&index=0&id=6b04a89c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b04a89c",
  null
  
)

export default component.exports